(function() {
  'use strict';

  function injectMobileMegamenus() {
    var templates = document.querySelectorAll('[data-mobile-megamenu]');
    if (!templates.length) return;

    templates.forEach(function(template) {
      var parentTitle = template.getAttribute('data-mobile-megamenu');
      /* Find matching mobile nav items in ALL drawers */
      var navItems = document.querySelectorAll('[data-mobile-nav-title="' + parentTitle + '"]');

      navItems.forEach(function(navItem) {
        /* Skip if already injected */
        if (navItem.querySelector('.megamenu-mobile')) return;

        var content = template.content.cloneNode(true);
        var hasDropdown = navItem.querySelector('.mobile-dropdown');

        if (hasDropdown) {
          /* Item has sub-links — replace dropdown content with megamenu */
          var collapsibleContent = hasDropdown.querySelector('[data-collapsible-content]');
          if (collapsibleContent) {
            collapsibleContent.innerHTML = '';
            collapsibleContent.appendChild(content);
          } else {
            hasDropdown.innerHTML = '';
            var wrapper = document.createElement('div');
            wrapper.setAttribute('data-collapsible-content', '');
            wrapper.appendChild(content);
            hasDropdown.appendChild(wrapper);
          }
        } else {
          /* Item has no sub-links (e.g. SHOP BY BENEFITS) — add accordion structure */
          navItem.classList.add('mobile-menu__item--has-items');

          /* Create trigger button */
          var trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = 'mobile-nav__trigger mobile-nav__trigger--level-1';
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('data-collapsible-trigger', '');

          trigger.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 192 192"><path d="M30 96h132M96 30v132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>');
          trigger.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-minus" viewBox="0 0 192 192"><path d="M30 96h132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>');

          /* Create dropdown container */
          var dropdown = document.createElement('div');
          dropdown.className = 'mobile-dropdown';
          dropdown.setAttribute('data-collapsible-container', '');

          var innerContent = document.createElement('div');
          innerContent.setAttribute('data-collapsible-content', '');
          innerContent.appendChild(content);
          dropdown.appendChild(innerContent);

          navItem.appendChild(trigger);
          navItem.appendChild(dropdown);

          /* Re-initialize Collapsible for this item */
          initCollapsible(navItem);
        }
      });
    });
  }

  function initCollapsible(container) {
    var triggers = container.querySelectorAll('[data-collapsible-trigger]');
    triggers.forEach(function(trigger) {
      if (trigger.hasAttribute('data-megamenu-collapsible-init')) return;
      trigger.setAttribute('data-megamenu-collapsible-init', '');

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        var parent = trigger.closest('.mobile-menu__item');
        if (!parent) return;

        var dropdownContainer = parent.querySelector('[data-collapsible-container]');
        var collapsibleContent = parent.querySelector('[data-collapsible-content]');
        if (!dropdownContainer || !collapsibleContent) return;

        var isExpanded = parent.classList.contains('is-expanded');

        if (isExpanded) {
          parent.classList.remove('is-expanded');
          dropdownContainer.classList.remove('is-expanded');
          trigger.setAttribute('aria-expanded', 'false');
          dropdownContainer.style.height = collapsibleContent.offsetHeight + 'px';
          requestAnimationFrame(function() {
            dropdownContainer.style.height = '0px';
          });
          setTimeout(function() {
            dropdownContainer.style.height = '';
          }, 500);
        } else {
          parent.classList.add('is-expanded');
          dropdownContainer.classList.add('is-expanded');
          trigger.setAttribute('aria-expanded', 'true');
          dropdownContainer.style.height = collapsibleContent.offsetHeight + 'px';
          setTimeout(function() {
            dropdownContainer.style.height = 'auto';
          }, 500);
        }
      });
    });
  }

  /*
   * The mobile megamenu lives in a <template>, so its markup costs nothing
   * until it is cloned into the document. Cloning it on every viewport put 26
   * benefit icons into the DOM of every desktop page load, where CSS hides the
   * whole menu anyway — 26 image requests and ~500 DOM nodes for markup nobody
   * could see. Injection now waits until the viewport is actually mobile, and
   * runs on resize for anyone who crosses the breakpoint mid-session.
   */
  var MOBILE_MAX_WIDTH = 767; /* matches window.theme.sizes.small - 1 */

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function injectIfMobile() {
    if (isMobileViewport()) injectMobileMegamenus();
  }

  function init() {
    injectIfMobile();

    /* Re-run on Shopify section reload */
    document.addEventListener('shopify:section:load', function() {
      setTimeout(injectIfMobile, 100);
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(injectIfMobile, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
